import { z } from 'zod';
const getMissionsAnalyticsResponseSchema = z.object({
    totalMissions: z.number(),
    totalParticipantHours: z.number(),
});
export const getMissionsAnalyticsFunctionDef = {
    name: 'getMissionsAnalytics',
    requestSchema: z.null(),
    responseSchema: getMissionsAnalyticsResponseSchema,
};
